import { api } from './queryInterceptors';

import type { AxiosResponse } from 'axios';
import type { PaginatedResponse } from '@/types/api';
import type { Language } from '@/types/batch';

/**
 * Retrieve the list of languages from the API.
 *
 * @return A Promise resolving to the Axios response containing the paginated list of languages.
 */
export async function languagesGetQuery(): Promise<AxiosResponse<PaginatedResponse<Language>>> {
  const requestOptions = {
    method: 'GET',
    url: `/languages/`
  };
  return api(requestOptions);
}